import { useState } from 'react'
import s from './Notes.scss'
import { Container, Button, Table } from 'reactstrap'
import { FaPlusCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa'
import { Note } from './Note'
import { AddButton } from 'components/common/AddButton'

const Notes = ({ notes, toggleAddNoteModal, hideCompay, hideContact, deleteNote }) => {
  const [allCollapsed, setAllCollapsed] = useState(false)

  const toggleAllCollapsed = () => {
    setAllCollapsed(!allCollapsed)
  }

  return (
    <Container className={s.container}>
      <AddButton className={s.addNoteBtn} onClick={() => toggleAddNoteModal(null)}>
        <FaPlusCircle />
        Add Note
      </AddButton>
      {notes && notes.length > 0 ? (
        <>
          <Button className={s.selectWhiteBtn} onClick={toggleAllCollapsed}>
            {allCollapsed ? <FaChevronUp /> : <FaChevronDown />}
            {allCollapsed ? 'Collapse All Notes' : 'Expand All Notes'}
          </Button>
          <Table borderless style={{ height: '100%' }}>
            <thead>
              <tr className={s.row}>
                <th>Updated At</th>
                <th>Updated By</th>
                {!hideContact && <th>Contact Name{!hideCompay && '/Company'}</th>}
                <th>Files</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody style={{ height: '100%' }}>
              {notes.map(note => (
                <Note
                  key={note.id}
                  note={note}
                  toggleAddNoteModal={toggleAddNoteModal}
                  hideCompay={hideCompay}
                  hideContact={hideContact}
                  allCollapsed={allCollapsed}
                  deleteNote={deleteNote}
                />
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <p className={s.noNotes}>Currently there are no notes. Please add one.</p>
      )}
    </Container>
  )
}

export default Notes
